import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { tutorAuthService } from '../services/tutorAuth';
import './Header.css';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const isAuthenticated = tutorAuthService.isAuthenticated();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const handleLogout = () => {
    tutorAuthService.logout();
    navigate('/login');
  };

  const INSTAGRAM_URL = 'https://www.instagram.com/losbichospetclub?igsh=MXI5bWxlYnU0d2M5ZA==';

  const handleShareWhatsApp = () => {
    const url = window.location.origin;
    const text = encodeURIComponent(`Conheça o Los Bichos PETCLUB! 🐾\n\nCuidados especiais para seu pet com planos de banho e serviços premium.\n\nSiga-nos no Instagram: ${INSTAGRAM_URL}\n\n${url}`);
    const whatsappUrl = `https://wa.me/?text=${text}`;
    window.open(whatsappUrl, '_blank');
  };

  const closeMenu = () => setMenuOpen(false);

  const navLinks = (
    <>
      <Link to="/" onClick={closeMenu}>Home</Link>
      <Link to="/planos" onClick={closeMenu}>Planos</Link>
      {isAuthenticated ? (
        <>
          <Link to="/meus-agendamentos" onClick={closeMenu}>Meus Agendamentos</Link>
          <Link to="/meus-pets" onClick={closeMenu}>Meus Pets</Link>
        </>
      ) : (
        <Link to="/login" onClick={closeMenu} className="btn-login">
          <span>Entrar</span>
        </Link>
      )}
      <button
        type="button"
        onClick={() => { handleShareWhatsApp(); closeMenu(); }}
        className="btn-share-whatsapp"
        title="Compartilhar no WhatsApp"
        aria-label="Compartilhar no WhatsApp"
      >
        <span className="share-icon">↗</span>
        <span className="share-label">Compartilhar</span>
      </button>
    </>
  );

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo">
            <span className="logo-main">LOS BICHOS</span>
          </Link>
          {/* Desktop: menu visível na barra */}
          <div className="nav-desktop">
            <Link to="/">Home</Link>
            <Link to="/planos">Planos</Link>
            <span className="nav-spacer" aria-hidden="true" />
            {isAuthenticated ? (
              <>
                <Link to="/meus-agendamentos">Meus Agendamentos</Link>
                <Link to="/meus-pets">Meus Pets</Link>
                <button type="button" onClick={handleLogout} className="btn-logout">
                  <span>Sair</span>
                </button>
              </>
            ) : (
              <Link to="/login" className="btn-login">
                <span>Entrar</span>
              </Link>
            )}
            <button
              type="button"
              onClick={handleShareWhatsApp}
              className="btn-share-whatsapp"
              title="Compartilhar no WhatsApp"
              aria-label="Compartilhar no WhatsApp"
            >
              <span className="share-icon">↗</span>
              <span className="share-label">Compartilhar</span>
            </button>
          </div>
          {/* Mobile: só logo + sair + hamburger na barra */}
          <div className="nav-mobile-actions">
            {isAuthenticated && (
              <button type="button" onClick={handleLogout} className="btn-logout">
                <span>Sair</span>
              </button>
            )}
            <button
              type="button"
              className="btn-hamburger"
              onClick={() => setMenuOpen(true)}
              aria-label="Abrir menu"
              aria-expanded={menuOpen}
            >
              <span className="hamburger-line" />
              <span className="hamburger-line" />
              <span className="hamburger-line" />
            </button>
          </div>
        </nav>
      </div>
      {/* Overlay do menu mobile (abre com animação) */}
      <div
        className={`menu-overlay ${menuOpen ? 'menu-overlay--open' : ''}`}
        aria-hidden={!menuOpen}
      >
        <button
          type="button"
          className="menu-overlay-close"
          onClick={closeMenu}
          aria-label="Fechar menu"
        >
          <span aria-hidden>×</span>
        </button>
        <div className="menu-overlay-content">
          {navLinks}
        </div>
      </div>
    </header>
  );
};

export default Header;

